import { Form } from '@sketchpixy/rubix';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import React from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm, change, initialize } from 'redux-form';
import _ from 'lodash';
import CustomField from '../Fields/CustomField.jsx';
import FormCardContainer from '../Elements/FormCardContainer.jsx';
import ExtensionGroupSelectorField from '../Fields/ExtensionGroupSelectorField.jsx';
import IntercomExtensionUsersSelectorField from '../Elements/IntercomExtensionUsersSelectorField.jsx';
import { MATCH_TAG_MODE, VIRTUAL_INTERCOM_EXTENSION_VISIBILITY } from '../../../_config/consts.js';
import FormFlatContainer from '../Elements/FormFlatContainer.jsx';
import VisibilityVisibleIconCustom from '../../CustomIcons/VisibilityVisibleIconCustom.jsx';
import VisibilityInvisibleIconCustom from '../../CustomIcons/VisibilityInvisibleIconCustom.jsx';
import { GREEN } from '../../../_config/consts.js';
import MDRadioButtonsGroupField from '../Elements/MDRadioButtonsGroup/MDRadioButtonsGroupField.js';
import BasicModal from '../../Modals/BasicModal.jsx';
import ExtensionGroupForm from './ExtensionGroupForm.jsx';
import MDButton from '../../MDButton/MDButton.jsx';
import * as IntercomActions from '../../../redux/actions/intercom.actions';
import * as UtilsActions from '../../../redux/actions/utils.actions';
import { submit } from 'redux-form';
import MDCheckBoxField from '../Fields/MDCheckBox/MDCheckBoxField.js';
import IntercomExtensionIconCustom from '../../CustomIcons/IntercomExtensionIconCustom.jsx';
import { PeopleAltOutlined } from '@material-ui/icons';
import InfoSection from '../../InfoSection/InfoSection.jsx';

const validate = (values, props) => {
  const errors = {};
  const { virtualIntercomLimits } = props;
  
  if (!values.name) {
    errors.name = 'required';
  }
  if (!values.group || !values.group.name) {
    errors.group = 'required';
  }
  
  // Max users validation
  if (virtualIntercomLimits && virtualIntercomLimits.maxUsersInExtension !== -1) {
    const userCount = values.userIds ? values.userIds.length : 0;
    if (userCount > virtualIntercomLimits.maxUsersInExtension) {
      errors.userIds = 'extensionMaxUsersExceeded';
    }
  }
  
  return errors;
};

@reduxForm({ form: 'ExtensionForm', validate })
@connect(state => ({ 
  form: state.form.ExtensionForm,
  extensionGroups: state.intercom.extensionGroups.content,
}))
class ExtensionForm extends React.Component {
  
  constructor(props) {
    super(props);
    this.state = {
      
    };
  }

  async componentDidMount() {
    const { extension } = this.props;
    this.init(extension)
  }

  componentWillReceiveProps(nextProps) {
    const { extension: extensionOld } = this.props;
    const { extension } = nextProps;
    if (extension.id!==extensionOld.id)
      this.init(extension)
  }

  async init(extension) {
    const { dispatch } = this.props;

    dispatch(change('ExtensionForm', 'users', extension.users || []));
    dispatch(change('ExtensionForm', 'userIds', extension.users ? extension.users.map(e=>{return e.id}) : []));
    dispatch(change('ExtensionForm', 'userTagMatchingMode', MATCH_TAG_MODE.AT_LEAST_ONE_TAG));
    dispatch(change('ExtensionForm', 'visibility', extension.visibility || VIRTUAL_INTERCOM_EXTENSION_VISIBILITY.VISIBLE));
  }

  updateUserIds(users) {
    const { dispatch } = this.props;
    const userIds_new = _.map(users,e=>{return e.id})
    dispatch(change('ExtensionForm', 'userIds', userIds_new));
  }

  showExtensionGroupModal(values) {
    const { dispatch } = this.props;
    dispatch(initialize('ExtensionGroupForm', { name: values && values.name }));
    this.newExtensionGroupModal.open();
  }
  
  async createExtensionGroup(values) {
    const { dispatch } = this.props;
    try {
      dispatch(UtilsActions.setSpinnerVisibile(true));
      const extensionGroup = await dispatch(IntercomActions.createExtensionGroup(values));
      await dispatch(IntercomActions.fetchExtensionGroups());
      dispatch(change('ExtensionForm', 'group', extensionGroup));
      this.newExtensionGroupModal.close();
    } finally {
      dispatch(UtilsActions.setSpinnerVisibile(false));
    }
  }
  
  render() {
    const { extensionGroups, form, 
      usersFilteredByTags, availableUserTags, onUserTagsChange, 
      onUserInputChange, onFetchMoreUsers, onUserFilterModeChange,
      virtualIntercomLimits,
      dispatch
    } = this.props;
    const initialUsers = form && form.values && form.values.users;
    const selectedVisibility = form && form.values && form.values.visibility;
    
    const isGroupingDisabled = virtualIntercomLimits && !virtualIntercomLimits.extensionGroupingActive;
    const isVisibilityControlDisabled = virtualIntercomLimits && !virtualIntercomLimits.extensionVisibilityControlActive;
    const hasMaxUsersLimit = virtualIntercomLimits && virtualIntercomLimits.maxUsersInExtension !== -1;
    const maxUsersAllowed = virtualIntercomLimits ? virtualIntercomLimits.maxUsersInExtension : -1;
    
    return (
      <Form>
          <FormFlatContainer
            title="extensionData"
            containerStyle={{ marginTop: 20, marginRight: 10 }}
            icon={<IntercomExtensionIconCustom style={{ width: 22, height: 22, marginBottom: 1 }} />}
            subtitle="extensionDataSubtitle"
          >
            <Entity
              componentClass={Field}
              name="name"
              componentAttribute="placeholder"
              entity="insertName"
              title={<Entity entity="name" />}
              component={CustomField}
              containerStyle={{ marginLeft: 5, marginTop: 15 }}
              type="text"
              mandatory
            />
            <Entity
              componentClass={Field}
              name="group"
              componentAttribute="placeholder"
              entity="extensionGroupInsert"
              title={<Entity entity="extensionGroup" />}
              component={ExtensionGroupSelectorField}
              categories={extensionGroups}
              containerStyle={{ marginLeft: 5 }}
              onNewOption={values => this.showExtensionGroupModal(values)}
              isCreatable
              mandatory
            />
          </FormFlatContainer>
          <FormFlatContainer
            title="extensionUsersSectionTitle"
            subtitle="extensionUsersSectionSubtitle"
            icon={<PeopleAltOutlined style={{ width: 22, height: 22, marginBottom: 1 }} />}
            containerStyle={{ marginRight: 10 }}
          >
            <div style={{paddingLeft: 6}}>
              <IntercomExtensionUsersSelectorField
                selectorFieldName="userTagMatchingMode"
                name="extensionUserTags"
                tags={availableUserTags}
                selectedTags={usersFilteredByTags}
                form={form}
                title="extensionUsersSearch"
                placeholder="extensionUsersSearchPlaceholder"
                listTitle="extensionUsersSearchResultsTitle"
                selectionSectionTitle="intercomExtensionUsersSelectionTitle"
                selectionSectionSubtitle={null}
                selectionSectionEmptySubtitle="intercomExtensionUsersSelectionEmpty"
                isOptional={true}
                initialValues={initialUsers || []}
                onFetchMoreItems={page => onFetchMoreUsers(page)}
                onTagsChange={values => onUserTagsChange(values)}
                onInputChange={value => onUserInputChange(value)}
                onFilterModeChange={values => onUserFilterModeChange(values)}
                onToggleUserId={users => this.updateUserIds(users)}
                virtualIntercomLimits={virtualIntercomLimits}
              />
              {hasMaxUsersLimit && (
                <InfoSection
                  gravity="info"
                  title={<Entity entity="extensionUsersLimitInfo" data={{ maxUsers: maxUsersAllowed }} />}
                  containerStyle={{ marginBottom: 15 }}
                />
              )}
            </div>
          </FormFlatContainer>
          <FormFlatContainer
            title="extensionVisibility"
            subtitle="extensionVisibilityDescription"
            icon={<VisibilityVisibleIconCustom style={{ width: 22, height: 22, marginTop: 3 }} />}
            containerStyle={{ marginRight: 10 }}
          >
            <div style={{ paddingLeft: 6 }}>
              <Field
                name="visibility"
                component={MDRadioButtonsGroupField}
                options={[
                  {
                    value: VIRTUAL_INTERCOM_EXTENSION_VISIBILITY.VISIBLE,
                    label: (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h5 style={{ color: GREEN, margin: 0, fontSize: 16, marginRight: 10 }}>
                          <Entity entity="extensionVisibilityVisible" />
                        </h5>
                        <VisibilityVisibleIconCustom style={{ width: 20, color: GREEN }} />
                      </div>
                    ),
                  },
                  {
                    value: VIRTUAL_INTERCOM_EXTENSION_VISIBILITY.HIDDEN,
                    label: (
                      <div style={{ display: 'flex', alignItems: 'center' }}>
                        <h5 style={{ color: 'grey', margin: 0, fontSize: 16, marginRight: 10 }}>
                          <Entity entity="extensionVisibilityHidden" />
                        </h5>
                        <VisibilityInvisibleIconCustom style={{ width: 20, color: 'grey' }} />
                      </div>
                    ),
                  },
                ]}
              />
              <div style={{ marginLeft: 0, marginBottom: 20, opacity: selectedVisibility === VIRTUAL_INTERCOM_EXTENSION_VISIBILITY.HIDDEN || isVisibilityControlDisabled ? 0.5 : 1 }}>
                <Field
                  name="isReception"
                  label={<Entity entity="enableVisibleOnTop" />}
                  titleStyle={{ fontSize: 16, fontWeight: 'bold', color: '#3f3f3f' }}
                  component={MDCheckBoxField}
                  disabled={selectedVisibility === VIRTUAL_INTERCOM_EXTENSION_VISIBILITY.HIDDEN || isVisibilityControlDisabled}
                />
                <h4 style={{ marginTop: -10, lineHeight: 1.5, marginLeft: 35, fontSize: 15, color: '#3f3f3f', fontWeight: 'light' }}>
                  <Entity entity="enableVisibleOnTopDescription" />
                </h4>
              </div>
              {isVisibilityControlDisabled && (
                <InfoSection
                  gravity="warning"
                  title="extensionVisibilityControlDisabled"
                  containerStyle={{ marginBottom: 15 }}
                />
              )}
            </div>
          </FormFlatContainer>
        <BasicModal
          ref={(m) => { this.newExtensionGroupModal = m; }}
          title={<Entity entity="newExtensionGroup" />}
          body={
            <div>
              <ExtensionGroupForm
                onSubmit={values => this.createExtensionGroup(values)}
              />
              <MDButton
                containerStyle={{ marginTop: 30 }}
                title={<Entity entity="createExtensionGroup" />}
                onClick={() => dispatch(submit('ExtensionGroupForm'))}
              />
            </div>
          }
        />
      </Form>
    );
  }
}

export default ExtensionForm; 